<template>
<v-container grid-list-xs>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <v-layout row justify-center>
      <v-btn x-large color="primary" class="ma-2 elevation-3" min-height="80px" min-width="300px" :to="item.path" :disabled="item.disabled" rounded v-for="(item, idx) in items" :key="'btn2'+idx">
        <v-layout column>
          <v-icon class="mb-3" x-large>{{item.icon}}</v-icon>
          {{item.title}}
        </v-layout>
      </v-btn>
    </v-layout>
  </div>
  <!-- importar o index do dashboard aqui -->
</v-container>
</template>

<script>
export default {
  name: 'HomeScreen',
  props: {
    msg: String
  },
  data() {
    return {
      items: [
        { title: 'Clientes',    path: '/clients', icon: 'mdi-star', disabled: false},
        { title: 'Fornecedores',        path: '/suppliers', icon: 'mdi-account-tie', disabled: false},
        { title: 'Dashboard',  path: '/dashboard', icon: 'mdi-finance', disabled: false },
        // { title: 'Processos',          path: '/salestender', icon: 'mdi-file-cabinet', disabled: true },
        // { title: 'Fluxo Financeiro',           path: '/financial', icon: 'mdi-currency-usd', disabled: true },
      ],
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.btn {
  /* text-align: center;
  font-size: 20px;
  color: pink;
  padding: 20px;
  margin:20px; */
}
</style>
